import {
  DEPARTMENT_FILTER_CHANGED,
  FETCH_DEPARTMENTS_TYPE,
  FETCH_JOBS_TYPE,
  FETCH_OFFICES_TYPE,
  OFFICE_FILTER_CHANGED,
} from '../actions';

const initialState = {
  filters: {
    departmentId: 0,
    officeId: 0,
  },
  departments: {
    busy: true,
    error: undefined,
    value: [],
  },
  offices: {
    busy: true,
    error: undefined,
    value: [],
  },
  jobs: {
    busy: true,
    error: undefined,
    value: [],
  },
};

const asyncActionReducer = (state, action, type, statePropertyName) => {
  switch (action.type) {
    case `${type}_PENDING`:
      return {
        ...state,
        [statePropertyName]: {
          busy: true,
          value: [],
        },
      };
    case `${type}_FULFILLED`:
      return {
        ...state,
        [statePropertyName]: {
          busy: false,
          error: undefined,
          value: action.payload,
        },
      };
    case `${type}_REJECTED`:
      return {
        ...state,
        [statePropertyName]: {
          busy: false,
          error: 'An error has occurred. Please try again later.',
          value: [],
        },
      };
    default:
      return undefined;
  }
};

const asyncActionsReducer = (state, action) => {
  const singleReducer = (type, statePropertyName) => asyncActionReducer(
    state,
    action,
    type,
    statePropertyName,
  );

  switch (action.type) {
    case DEPARTMENT_FILTER_CHANGED:
      return {
        ...state,
        filters: {
          ...state.filters,
          departmentId: action.payload.departmentId,
        },
      };
    case OFFICE_FILTER_CHANGED:
      return {
        ...state,
        filters: {
          ...state.filters,
          officeId: action.payload.officeId,
        },
      };
    default:
      return (
        singleReducer(FETCH_DEPARTMENTS_TYPE, 'departments')
        || singleReducer(FETCH_OFFICES_TYPE, 'offices')
        || singleReducer(FETCH_JOBS_TYPE, 'jobs')
      );
  }
};

const greenhouse = (state = initialState, action) => (
  asyncActionsReducer(state, action)
  || state
);

export default greenhouse;
